import { gql } from "@apollo/client";

const INSTANCE_SUMMARY_FIELDS = `
  id
  name
  artistNames
  edition {
    id
    artwork {
      id
      title
      imagesSummary {
        imgT
      }
    }
  }
`;

const SEARCH_RESULT_FIELDS = `
  type
  id
  label
  instance {
    ${INSTANCE_SUMMARY_FIELDS}
  }
  invoice {
    id
    approved
    companyName
    contact {
      id
      name
    }
    currency {
      code
    }
    invoiceTotals
    isExported
  }
  artist {
    id
    name
  }
  artwork {
    id
    title
    artists {
      id
      name
    }
    imagesSummary {
      imgT
    }
  }
  consignment {
    id
    consigneeName
    consigneeCompany
    consigner {
      id
      name
    }
  }
  contact {
    id
    name
    company
  }
  exhibition {
    id
    title
    type
    curator
  }
  job {
    id
    description
    jobType {
      id
      description
    }
    jobStatus {
      id
      description
    }
  }
  offer {
    id
    artwork {
      id
      title
      artists {
        id
        name
      }
      imagesSummary {
        imgT
      }
    }
    contact {
      id
      name
    }
    status {
      id
      description
    }
  }
  reservation {
    id
    description
    reservationUser {
      id
      name
    }
  }
  shipment {
    id
    shippingRef
    delCompany
    consignee {
      id
      name
    }
  }
  warehouseItem {
    id
    description
    itemDescription
    instance {
      ${INSTANCE_SUMMARY_FIELDS}
    }
  }
`;

const REFERENCE_SEARCH = gql`
  query ReferenceSearch($query: String!, $limit: Int) {
    referenceSearch(query: $query, limit: $limit) {
      ${SEARCH_RESULT_FIELDS}
    }
  }
`;

const MODULE_SEARCH = gql`
  query ModuleSearch($module: SearchModule!, $query: String!, $limit: Int) {
    moduleSearch(module: $module, query: $query, limit: $limit) {
      ${SEARCH_RESULT_FIELDS}
    }
  }
`;

export { MODULE_SEARCH, REFERENCE_SEARCH };
